import * as React from 'react'

import { DocumentNode } from '@apollo/client'
import {
  Box,
  Button,
  useConfirmationDialog,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { PerformanceCyclesCycle } from 'generated/resources/datatable.graphql'
import { DeletePerformanceCycleDocument } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { UpdateCycleModal } from 'modules/performance_cycles/components/UpdateCycleModal'

export const Actions: React.FC<{
  cycle: PerformanceCyclesCycle
  refetchQueries?: DocumentNode[]
}> = ({ cycle, refetchQueries = [] }) => {
  const [showEditeModal, toggleEditModal] = useToggle()

  const { openDialog } = useConfirmationDialog()

  const [deleteCycle, { loading: deleteLoading }] = useMutation(DeletePerformanceCycleDocument, {
    extractorFn: (data) => data.performanceCyclesMutations.deletePerformancecyclesCycle,
  })

  const onDelete = async () => {
    const result = await deleteCycle({
      variables: { id: cycle.id },
      update(cache) {
        cache.evict({ id: cache.identify({ id: cycle.id, __typename: 'PerformanceCyclesCycle' }) })
      },
      refetchQueries,
      awaitRefetchQueries: true,
    })

    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    }

    return handled
  }

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <Box flexDirection="row" justifyContent="flexEnd" alignItems="center" gap="s8">
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>

          <PopoverMenu.Content side="bottom" align="start">
            <PopoverMenu.TouchableOption
              title={i18n.t('common.edit')}
              onClick={toggleEditModal(true)}
            />
            <PopoverMenu.TouchableOption
              danger
              title={i18n.t('common.delete')}
              disabled={deleteLoading}
              onClick={() =>
                openDialog({
                  title: i18n.t('performance_cycles.delete_cycle.title'),
                  illustration: 'alert',
                  description: i18n.t('performance_cycles.delete_cycle.description'),
                  confirmLabel: i18n.t('performance_cycles.delete_cycle.confirm'),
                  onConfirm: onDelete,
                })
              }
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>

      {showEditeModal && <UpdateCycleModal cycle={cycle} onClose={toggleEditModal(false)} />}
    </Box>
  )
}
